import { Components } from '@icc/window-door/types';

/**
 * Zwraca identyfikatory sashes które należy pominąć na podstawie komponentów drzwi
 */
export function getSashIdsToSkipBaseOnComponent(components: Components, conf, sashes): number[] {
    const sashesIdToSkip = [];
    if (components) {
        const notDoorSash = (sash) => ['DRA', 'DRP', 'DOA', 'DOP'].indexOf(sash.type.type) === -1;
        const isDoorLight = (sash) => conf.type === 'door' && notDoorSash(sash);
        const isLeftLight = (sash) => {
            const frame = conf.Frames.find(f => f.id === sash.frameId);
            return isDoorLight(sash) && sash.nearMullions.left === -1 && ((frame && frame.x) || 0) + sash.rx === 0;
        };
        const isRightLight = (sash) => {
            const frame = conf.Frames.find(f => f.id === sash.frameId);
            return isDoorLight(sash) && sash.nearMullions.right === -1 && ((frame && frame.x) || 0) + sash.rx > 0;
        };
        const isTopLight = (sash) => {
            const frame = conf.Frames.find(f => f.id === sash.frameId);
            return isDoorLight(sash) && frame.y + sash.ry + sash.rHeight < conf.Height;
        };

        if (!components.activeSash) {
            sashesIdToSkip.push(sashes.find(sash => ['DRA', 'DOA'].includes(sash.type.type)).id);
        }
        if (!components.passiveSash) {
            sashesIdToSkip.push(sashes.find(sash => ['DRP', 'DOP'].includes(sash.type.type)).id);
        }
        if (!components.sideLight.left) {
            sashesIdToSkip.push(sashes.find(sash => isLeftLight(sash)).id);
        }
        if (!components.sideLight.right) {
            sashesIdToSkip.push(sashes.find(sash => isRightLight(sash)).id);
        }
        if (!components.sideLight.top) {
            sashesIdToSkip.push(sashes.find(sash => isTopLight(sash)).id);
        }
    }
    return sashesIdToSkip;
}
